import { useEffect, useState } from "react"
import React from "react"

function Wallet() {
  const language = process.env.REACT_APP_LANGUAGE || "en"

  const text = {
    en: {
      withoutfee: "Without Annual Fee",
      withfee: "With Annual Fee",
    },
    zh: {
      withoutfee: "无年费信用卡",
      withfee: "有年费信用卡",
    },
  }

  const [cards, setCards] = useState([])

  useEffect(() => {
    // Dynamic import based on environment variable
    import(`../data/CardData-${process.env.REACT_APP_LANGUAGE}.jsx`)
      .then(module => setCards(module.default))
      .catch(error => console.error("Failed to load card data:", error))
  }, [])

  const withFee = cards.filter(card => card.annualFee > 0)
  const withoutFee = cards.filter(card => card.annualFee === 0)

  return (
    <div className="container mx-auto px-4 py-8">
      {/* Without Annual Fee Section */}
      <section className="mb-12">
        <h2 className="text-2xl font-bold mb-4">{text[language].withoutfee}</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
          {withoutFee.map(card => (
            <a
              key={card.id}
              href={`/card/${card.id}`}
              className="block relative rounded-lg overflow-hidden shadow-md hover:shadow-lg transition"
            >
              <img src={card.image} alt={card.name} className="w-full h-auto" />
              {/* Conditional rendering for the Hot Offer badge */}
              {card.hotOffer && (
                <span className="absolute top-2 right-2 bg-red-600 text-white text-xs font-bold px-2 py-1 rounded-full">
                  Hot Offer! 🔥
                </span>
              )}
            </a>
          ))}
        </div>
      </section>

      {/* With Annual Fee Section */}
      <section>
        <h2 className="text-2xl font-bold mb-4">{text[language].withfee}</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
          {withFee.map(card => (
            <a
              key={card.id}
              href={`/card/${card.id}`}
              className="block relative rounded-lg overflow-hidden shadow-md hover:shadow-lg transition"
            >
              <img src={card.image} alt={card.name} className="w-full h-auto" />
              {/* Conditional rendering for the Hot Offer badge */}
              {card.hotOffer && (
                <span className="absolute top-2 right-2 bg-red-600 text-white text-xs font-bold px-2 py-1 rounded-full">
                  Hot Offer! 🔥
                </span>
              )}
            </a>
          ))}
        </div>
      </section>
    </div>
  )
}

export default Wallet
